import StackViewport from '../StackViewport';
import VolumeViewport from '../VolumeViewport';
import ViewportType from '../../enums/ViewportType';
import LegacyVolumeViewport3D from '../VolumeViewport3D';
import VideoViewport from '../VideoViewport';
import WSIViewport from '../WSIViewport';
import LegacyECGViewport from '../ECGViewport';
import ECGViewport from '../GenericViewport/ECG/ECGViewport';
import PlanarViewport from '../GenericViewport/Planar/PlanarViewport';
import PlanarViewportLegacyAdapter from '../GenericViewport/Planar/PlanarViewportLegacyAdapter';
import NextVideoViewport from '../GenericViewport/Video/VideoViewport';
import VideoViewportLegacyAdapter from '../GenericViewport/Video/VideoViewportLegacyAdapter';
import VolumeViewport3D from '../GenericViewport/Volume3D/viewport3D';
import VolumeViewport3DLegacyAdapter from '../GenericViewport/Volume3D/VolumeViewport3DLegacyAdapter';
import NextWSIViewport from '../GenericViewport/WSI/WSIViewport';
import WSIViewportLegacyAdapter from '../GenericViewport/WSI/WSIViewportLegacyAdapter';
import ECGViewportLegacyAdapter from '../GenericViewport/ECG/ECGViewportLegacyAdapter';
const viewportTypeToViewportClass = {
    [ViewportType.ORTHOGRAPHIC]: VolumeViewport,
    [ViewportType.PERSPECTIVE]: VolumeViewport,
    [ViewportType.STACK]: StackViewport,
    [ViewportType.VOLUME_3D]: LegacyVolumeViewport3D,
    [ViewportType.WHOLE_SLIDE]: WSIViewport,
    [ViewportType.ECG]: LegacyECGViewport,
    [ViewportType.VIDEO]: VideoViewport,
    [ViewportType.VOLUME_3D_NEXT]: VolumeViewport3D,
    [ViewportType.PLANAR_NEXT]: PlanarViewport,
    [ViewportType.VIDEO_NEXT]: NextVideoViewport,
    [ViewportType.ECG_NEXT]: ECGViewport,
    [ViewportType.WHOLE_SLIDE_NEXT]: NextWSIViewport,
};
export default viewportTypeToViewportClass;
export function getViewportClassForInput({ type, requestedType, }) {
    if (type === ViewportType.PLANAR_NEXT &&
        (requestedType === ViewportType.STACK ||
            requestedType === ViewportType.ORTHOGRAPHIC)) {
        return PlanarViewportLegacyAdapter;
    }
    if (type === ViewportType.VIDEO_NEXT &&
        requestedType === ViewportType.VIDEO) {
        return VideoViewportLegacyAdapter;
    }
    if (type === ViewportType.ECG_NEXT && requestedType === ViewportType.ECG) {
        return ECGViewportLegacyAdapter;
    }
    if (type === ViewportType.WHOLE_SLIDE_NEXT &&
        requestedType === ViewportType.WHOLE_SLIDE) {
        return WSIViewportLegacyAdapter;
    }
    if (type === ViewportType.VOLUME_3D_NEXT &&
        requestedType === ViewportType.VOLUME_3D) {
        return VolumeViewport3DLegacyAdapter;
    }
    return viewportTypeToViewportClass[type];
}
